export const ja = {
    // Common
    error: 'エラーが発生する',
    success: '成功',
    confirm_delete_many: 'これらのアイテムを削除しますか',
    confirm_delete_one: '本当に削除しますか？',
    admin: '管理者',
    teacher: '教師',
    student: '学生',
    class: 'クラス',
    alert_go_back: '変更内容は保存されませんが。よろしいですか？',
    add: '追加',

    // Form message
    email_validation_message: '入力は有効な電子メールではありません',
    phone_number_message: '電話番号には数字のみを含める必要があります',
    required_field: 'この項目は必須です',
    invalid_format: '無効な形式',
    email_is_already_taken: 'メールは既に使用されています',
    invalid_password: '無効なパスワード',

    // Login
    signin: 'ログイン',
    welcome: 'ABK COLLEGE',
    email: 'メール',
    password: 'パスワード',
    login: 'ログイン',
    input_id: 'ID 入力',
    input_password: 'パスワード入力',

    // Forgot password
    forgot: 'パスワードをお忘れましたか',
    forgot_password: 'パスワードをお忘れですか',
    reset_link_was_sent: 'パスワード リセット リンクがメール アドレスに送信されました',
    enter_valid_email: '有効なメールアドレスを入力してください。',
    back: '戻る',
    send: '送信',
    email_address: 'メールアドレス',
    input_email: 'メール入力する',
    text_email_account:
        'アカウントに関連付けられている電子メールを入力すると、パスワードをリセットする手順が記載された電子メールが送信されます。',
    check_email: 'メールを確認してください',
    text_check_email: 'パスワードの回復手順をメールで送信しました',
    open_email: 'メールを開た',
    skip_confirm: '、後で確認します。',

    // Reset password
    create: '新しいパスワードを作成してください',
    reset_password: 'パスワードリセット',
    text_new_password: '新しいパスワードは、以前に使用したパスワードとは異なる必要があります。',
    confirm_password: 'パスワード確認',
    re_enter_password: 'パスワード再入力',
    extra_password: '最低 8 文字、少なくとも 1 つの文字、1 つの数字、および 1 つの特殊文字',
    extra_confirm_password: '両方のパスワードが一致する必要があります。',
    change_password_text: 'パスワードを正常変更',

    // Header
    logout: 'ログアウト',

    // Sidebar
    dashboard: 'ダッシュボード',
    teacher_page: '教師管理',
    student_page: '学生管理',
    class_page: 'クラス管理',
    learning_page: '教材管理',

    // Dashboard
    analytics: '分析',
    weekly: '毎週',
    monthly: '毎月',
    analytics_user: 'アプリを利用している学生数',
    analytics_n5: '(N5) 学習済み単語数',
    analytics_n4: '(N4) 学習済み単語数',
    teacher_dashboard: '教師数',
    student_dashboard: '学生数',
    class_dashboard: 'クラス数',

    // Overview
    overview: '概要',

    // Teacher management
    edit_teacher: '先生を編集',
    search_teachers: '教員検索',
    delete: '削除',
    add_new: '新規追加',
    add_to_class: 'クラスを追加',
    teacher_name: '教員名',
    status: '状態',
    decentralization: '分権',
    select_decentralization: 'Select decentralization',
    action: '操作',
    add_teacher: '教師を追加',
    cancel: 'キャンセル',
    save: '保存',
    ok: 'Ok',
    course: 'コース',
    input_name_add: '名前を入力してください',
    input_password_add: 'パスワードを入力してください',
    input_class_add: '担当クラスを選ぶ',
    input_email_add: 'メールを入力してください',
    input_phone_add: '電話番号を入力してください',
    message_role: '{{val}}の役割を{{val1}}に変更してもよろしですか？',
    text_role: 'このアカウントは、{{val3}}',
    text_role_1: 'システムの管理権限を失うことになります。',
    text_role_2: 'システム管理権限が付与されます。',

    // Class management
    select_class: 'クラスを選ぶ',
    select_teacher: '担当の先生を選択',
    teacher_charge: '担当教員',
    input_name: 'クラス名を入力',
    add_student: ' 学生を追加',
    student_name: '学生名',

    // Student management
    select_class_student: 'クラスを選ぶ',
    add_student_class: '追加',
    scoreboard: '採点',
    search_student: '学生検索',
    mobile: '電話番号',
    edit_student: '学生を編集',
    search_class: 'クラスを検索',
    class_list: 'クラスリスト',
    teacher_in_charge: '担当教員',
    view: '見る',
    add_class: 'クラスを追加',
    class_name: 'クラス名',
    change: '変更',
    upload: 'アップロード',
    student_list: '学生リスト',
    student_number: '学生数',
    print: '印刷する',
    download: 'ダウンロード',
    time: '時間',
    writing_result_photo: '書き込み結果写真',
    reading_result_photo: '読み取り結果写真',
    nickname: 'ニックネーム',
    nationality: '国籍',
    birthday: '生年月日',
    input_nickname: 'ニックネームを入力してください',
    input_nationality: '国籍を入力してください',
    input_birthday: '生年月日を入力してください',

    // Kanji management
    add_kanji: '新しい漢字を追加',
    edit_kanji: '漢字編集',
    search_kanji: '漢字を検索',
    kanji: '漢字',
    input_kanji: '漢字を入力する',
    level: 'レベル',
    input_level: 'レベルを入力する',
    how_to_read_kanji: '漢字の読み方',
    how_to_read_kanji_kun: '漢字の読み方 (KUN)',
    how_to_read_kanji_on: '漢字の読み方 (ON)',
    convention_kun: '訓読みを入力する',
    convention_on: '音読みを入力する',
    add_btn: '+ 追加',
    example_sentence: '例文',
    input_example_sentence: '例文を入力する',
    demonstrative: '指示語',
    demonstrative_help: '主な漢字は**に配置されます',
    input_demonstrative: '指示語を入力する',
    learn: '練習文字',
    input_learn: '練習文字を入力する',
    video_url: 'ビデオURL',
    input_video_url: 'ビデオURLを入力する',
    video_start: 'ビデオ開始',
    input_video_start: 'ビデオ開始を入力する',
    video_end: 'ビデオ終了',
    input_video_end: 'ビデオ終了を入力する',

    // Profile
    profile: 'プロフィール',
    account_settings: 'アカウント設定',
    submit: '送信',
    change_password: 'パスワード変更',
    old_password: '古いパスワード',
    new_password: '新しいパスワード',
    full_name: 'フルネーム',
    confirm_password_not_match: 'パスワードと確認パスワードは同じである必要があります',

    // Notification
    notify: '通知',
    send_notification: 'プッシュ通知',
    title: 'タイトル',
    content: '内容',
    input_title: 'タイトルを入力してください',
    input_content: '内容を入力してください',
    default_title: 'Reminder from teacher',
    default_content: 'You need to keep learning!',

    // Request error message
    username_or_password_is_not_correct: 'ユーザー名またはパスワードが正しくありません。',
    account_is_not_active: 'アカウントが有効ではありません。',
    account_is_deleted_by_admin: 'アカウントは管理者によって削除されました。',
    you_are_not_allowed_to_login_here: 'ここではログインできません。',
    user_not_found: 'ユーザーが見つかりません。',
    invalid_access_token: 'Access_token が無効です。',
    email_not_found: 'メールが見つかりません。',
    email_is_valid: '有効なメールです。',
    unauthorized: '不許可',
    permission_not_granted: '権限を付与されません。',
    invalid_class_id: 'クラスIDが無効です。',
    invalid_file_type: '無効なファイル形式です。',
    cannot_assign_admin_to_class: '管理者をクラスに追加できません。',
    class_already_have_teacher: 'このクラスには既に教師がいます。',
    student_is_already_assigned_to_a_class: '学生は既にクラスに割り当てられています。',
    invalid_number_of_teachers: '教師数が無効です。',
    invalid_spelling_word: 'ひらがなが無効です。',
    invalid_kanji_word_id: 'ID 漢字が無効です。',
    learn_word_is_required: '練習文字を入力する必要があります。',
    invalid_learn_convention: '練習文字が無効です。',
    invalid_user_id: 'ユーザーIDが無効です。',
    student_cannot_be_assigned_to_more_than_one_class: '他のクラスに学生を追加することはできません。',
    invalid_data: 'データが無効です。',
    class_not_found_or_not_allowed_to_be_accessed: 'クラスが見つからない、またはアクセスが許可されていません。',
    teacher_is_not_in_charge_of_this_class: '教師はこのクラスを担当していません。',
    student_not_found_or_not_allowed_to_be_accessed: '学生が見つからない、またはアクセスが許可されていません。',
    permission_denied: 'アクセスする権限がありません。',
    db_exception_occurred: 'データベース例外が発生しました',
    server_exception_occurred: 'サーバー例外が発生しました',
    found_no_device_id: 'デバイス ID が見つかりません',
    'Bad Request Exception': 'リクエストが無効です。',
    cannot_delete_yourself: 'Cannot delete yourself',
};
